import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { ManutencaoReembolsoListComp } from 'pages/financeiro/reembolso/manutencao-reembolso/components';

export function ManutencaoReembolsoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['FINANCEIRO_REEMBOLSO_MANUTENCAO'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <ManutencaoReembolsoListComp />
        </ListagemProvider>
    );
}
